import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ActivityGenerator from "./pages/ActivityGenerator";
import ActivityDetail from "./pages/ActivityDetail";
import ActivityLibrary from "./pages/ActivityLibrary";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import AuthCallback from "./pages/auth/AuthCallback";
import Dashboard from "./pages/dashboard/Dashboard";
import ExposureReport from "./pages/dashboard/ExposureReport";
import Guide from "./pages/Guide";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Account from "./pages/Account";
import { Toaster, toast } from "@/components/ui/sonner";

function AppContent() {
  const location = useLocation();

  // Clear all toasts on any route change / navigation
  useEffect(() => {
    toast.dismiss();
  }, [location.pathname]);

  // Handle Emergent Google OAuth callback (session_id in URL fragment) before rendering routes
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/generate" element={<ActivityGenerator />} />
          <Route path="/library" element={<ActivityLibrary />} />
          <Route path="/activity/:id" element={<ActivityDetail />} />
          <Route path="/report/:childId" element={<ExposureReport />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/account" element={<Account />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          closeButton
          visibleToasts={2}
          duration={4000}
          style={{ zIndex: 40 }}
        />
      </div>
    </AuthProvider>
  );
}

export default App;
